import axios from "axios";

function poster(organisation_id, name) {
  axios.post('/api/api/completions', {
    organisation_id: organisation_id,
    name: name
  })
    .then(function(response) {
      // console.log(response);
    })
    .catch(function(error) {
      // console.log(error);
    });
}

// Start the process
function init(interactiveID) {
  axios.get('/api/api/organisations')
    .then(function(response) {
      // handle success
      startQuiz(interactiveID, response.data);
      // console.log();
    })
    .catch(function(error) {
      // handle error
      // console.log(error);
      let defaults = [
        {
          id: 1,
          name: "Default 1"
        },
        {
          id: 2,
          name: "Default 2"
        },
        {
          id: 3,
          name: "Default 3"
        }
      ];
      startQuiz(interactiveID, defaults);
    })
    .then(function() {
      // always executed
      // console.log('axios get done')
    });
}

function startQuiz(interactiveID, organisations) {
  let currentQuizIndex = 0;
  const quizForm = document.getElementById(interactiveID);
  let quizStr = `
  <section id="start" class="">
    <p class="text-black">The Self-Reflection Tool is designed for individuals or teams with a customer service aspect 
    to their work. It provides an option for honest self-assessment through a quick thought-provoking exercise. 
    The Self-Reflection Tool aims to raise awareness and, along with the rest of this guide, support decision making about where and how to improve.</p>
    
       <p class="text-black italic">Before starting the Self-Reflection please select your organisation from the dropdown list below. 
       If your organisation does not appear in the dropdown list below please select other and enter your organisation. Ensure you complete all sections to receive your score/feedback.</p>
    
 <div class="mb-5 relative w-full xl:w-1/2 lg:w-1/2 md:w-1/2">
            <select id="getFname" class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mt-10">
            <option disabled selected value > -- select an option -- </option>`;

  let quizStrOptions = ``;
  organisations.forEach(function(org) {
    quizStrOptions += `<option value="` + org.id + `">` + org.name + `</option>`;
  });

  let quizStr2 = `
              <option value="other" id="admOption" >Other</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
          <div id="optionText" class="text-red-500 w-full hidden xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"><p>Please select an organisation from th list. If your organisation is not in the list please select other and enter your organisation.</p></div>
          <div class="mt-5 relative w-1/2">
          <div id="admDivCheck" style="display:none;">
            <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="organisationName" type="text" placeholder="Enter your organisation" maxLength="100">
          </div>
           <div id="optionOrg" class="text-red-500 w-1/2 hidden"><p>Please enter your organisation.</p></div>
          </div>
           <div class="mb-5 mt-16">
    <button id="startBtn" class="btn1 bg-sa-grey-dark hover:bg-sa-cyan text-sa-blue hover:text-white font-semibold py-4 px-8 rounded-full mb-10 float-left w-full text-2xl md:w-1/4 sm:mt-0 xs:mt-0 lg:w-1/4 xl:w-1/4">Start</button>
    </div>
    </section>`;

  quizForm.innerHTML = quizStr + quizStrOptions + quizStr2;

  document.getElementById("getFname").onchange = function(e) {
    if (this.value === 'other') {
      document.getElementById("admDivCheck").style.display = "";
    } else {
      document.getElementById("admDivCheck").style.display = "none";
    }
  };
  document.getElementById('results').classList.add("hidden");
  document.getElementById("startBtn").addEventListener("click", function(e) {
    let combo = document.getElementById("getFname");
    let organisationNameLength = document.getElementById("organisationName").value.length;

    if (combo.selectedIndex <= 0) {
      // ??
      document.getElementById('optionText').classList.remove("hidden");
    } else if (combo.value === 'other' && organisationNameLength <= 3) {
      // ??
      document.getElementById('optionText').classList.add("hidden");
      document.getElementById('optionOrg').classList.remove("hidden");
    } else {
      // ??
      document.getElementById('heading').classList.add("hidden");

      // poster(combo.selectedIndex, 'Ageing Well Quiz');
      saveOrg();
      buildQuiz(interactiveID, currentQuizIndex);
    }
  });
}

function buildQuiz(interactiveID, quizIndex) {
  let score = 0;
  let questionIndex = 0;
  let currentQuiz = quizzes[quizIndex];
  let currentQuestions = questions[currentQuiz.key];
  const quizForm = document.getElementById(interactiveID);
  let question = currentQuestions[questionIndex];

  let quizStr = `
 <section id="startQuiz">
        <h3 class="text-black pl-5 mb-2">${currentQuiz.name} <span id="quizScore" class="float-right font-medium pr-5"></span></h3>
        <div id="quizQuestion">
        </div>
    </section>`;
  quizForm.innerHTML = quizStr;

  buildQuestion(currentQuestions, questionIndex);
  addScore(score);
  addEvents(quizForm, questionIndex, quizIndex, interactiveID);
}

function buildQuestion(currentQuestions, questionIndex) {
  let question = currentQuestions[questionIndex];
  let answerStr = buildAnswers(question.a, question, 0);
  const quizQuestion = document.getElementById("quizQuestion");

  let questionStr =
    `<div class="flex-none border-b-8 border-${question.c} pb-0 ml-72 w-full xl:w-full lg:w-full xl:w-full md:w-full sm:w-full xs:w-full mb-10">
    </div>
  <div><p class="text-black pl-5 mb-1">Question<span class="mb-0 text-black">&nbsp;${questionIndex + 1}</span> of 5</p></div>
        <div class="flex content-start flex-wrap">
           <div class="w-1/12 pr-2"><div id="background0" class="text-gray-700 text-center  bg-${question.c} p-1"></div></div>
           <div class="w-1/12 pr-2"><div id="background1" class="text-gray-700 text-center  backcol p-1"></div></div>
           <div class="w-1/12 pr-2"><div id="background2" class="text-gray-700 text-center  backcol p-1"></div></div>
           <div class="w-1/12 pr-2"><div id="background3" class="text-gray-700 text-center  backcol p-1"></div></div>
           <div class="w-1/12 pr-2"><div id="background4" class="text-gray-700 text-center  backcol p-1"></div></div>
</div>

<div class="flex justify-center mt-12 mb-12 ">
  <div class="w-full xl:w-1/2 lg:w-1/2 md:w-2/3 sm:w-5/6 xs:w-5/6">
  <img class="transition-opacity" alt="Question ${questionIndex + 1}" src="/assets/questions/${question.q}">
  <span class="sr-only">${question.txt}</span>
  </div>
</div>
    
    <form>
        <span style="display:flex;" class="flex-wrap justify-center">
            ${answerStr}
        </span>  
    </form>
    `;

  quizQuestion.innerHTML = questionStr;

  if (questionIndex === 1) {
    document.getElementById('background1').classList.remove('backcol');
    document.getElementById('background1').classList.add(`bg-${question.c}`);
  } else if (questionIndex === 2) {
    document.getElementById('background1').classList.remove('backcol');
    document.getElementById('background1').classList.add(`bg-${question.c}`);
    document.getElementById('background2').classList.remove('backcol');
    document.getElementById('background2').classList.add(`bg-${question.c}`);
  } else if (questionIndex === 3) {
    document.getElementById('background1').classList.remove('backcol');
    document.getElementById('background1').classList.add(`bg-${question.c}`);
    document.getElementById('background2').classList.remove('backcol');
    document.getElementById('background2').classList.add(`bg-${question.c}`);
    document.getElementById('background3').classList.remove('backcol');
    document.getElementById('background3').classList.add(`bg-${question.c}`);
  } else if (questionIndex === 4) {
    document.getElementById('background1').classList.remove('backcol');
    document.getElementById('background1').classList.add(`bg-${question.c}`);
    document.getElementById('background2').classList.remove('backcol');
    document.getElementById('background2').classList.add(`bg-${question.c}`);
    document.getElementById('background3').classList.remove('backcol');
    document.getElementById('background3').classList.add(`bg-${question.c}`);
    document.getElementById('background4').classList.remove('backcol');
    document.getElementById('background4').classList.add(`bg-${question.c}`);
  }

}
// Add the events for the form
function addEvents(quizForm, questionIndex, quizIndex, interactiveID) {
  let currentQuiz = quizzes[quizIndex];
  let currentQuestions = questions[currentQuiz.key];
  let delay = (function() {
    let timer = 0;
    return function(callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();

  let score = 0;
  let numQuiz = Object.keys(quizzes).length;

  quizForm.addEventListener('change', function(e) {
    e.preventDefault();
    const inputFields = quizForm.querySelectorAll('input');
    const selectedField = quizForm.querySelector('input[type="radio"]:checked');
    const bg = e.target.querySelectorAll("input[type=radio]");
    if (selectedField === null) {
    } else if (selectedField.dataset.correct === "true") {
      selectedField.parentElement.parentElement.classList.add("mystyle");
      selectedField.parentElement.classList.add("mystyle1");
      selectedField.parentElement.parentElement.classList.add("selected_text");
      score += 1;

      bg.forEach(function(question) {
        question.disabled = true;
        question.parentElement.classList.remove("mySelectedStyle");
      });
      inputFields.forEach(function(question) {
        question.parentElement.classList.remove("my1");
        question.parentElement.parentElement.classList.remove("my");
        question.disabled = true;
      });
    } else if (selectedField.dataset.correct === "false") {
      selectedField.parentElement.parentElement.classList.add("selected_text");
      selectedField.parentElement.classList.add("my1");

      bg.forEach(function(question) {
        question.disabled = false;
        question.parentElement.classList.remove("mySelectedStyle");
      });
      inputFields.forEach(function(question) {
        question.parentElement.parentElement.classList.remove("mystyle");
        question.parentElement.classList.remove("mystyle1");
        question.disabled = true;
      });
    } else {
    }
    delay(function() {
      addScore(score);
      if (questionIndex + 1 < currentQuestions.length) {
        questionIndex++;
        removeEventListener('change', quizForm);
        buildQuestion(currentQuestions, questionIndex);
      } else {

        const quizQuestion = document.getElementById("quizQuestion");
        let quizStr = `
<div id="next">
<div class="mt-8 ">
<h4 class="text-black">Continue to the next section</h4>
</div>
<div class="mt-8 mb-20"> 
                <button id="nextBtn" class="btn1 bg-sa-grey-dark hover:bg-sa-cyan text-sa-blue hover:text-white font-semibold py-4 px-8 rounded-full float-left w-full text-2xl md:w-1/4 sm:mt-0 xs:mt-0 lg:w-1/4 xl:w-1/4">Continue</button>
                </div>
                </div>
`;

        // if(quizIndex === 4){
        //   document.getElementById('optionText').classList.add("hidden");
        //   document.getElementById('optionOrg').classList.remove("hidden");
        // }
        //
        quizQuestion.innerHTML = quizStr;

        document.getElementById("nextBtn").addEventListener("click", function(e) {
          saveScore(score, quizIndex);
          if ((quizIndex +1) < numQuiz) {
            quizIndex++;
            buildQuiz(interactiveID, quizIndex);
            console.log(quizIndex);
          }  });
        if (quizIndex === 4) {

          let quizStr = `
                            
                <div id="finish" class="mt-10">   
                 <h4 class="text-black mb-10">Well done! You have completed the Self-Reflection</h4> 
                <button id="show" class="btn1 bg-sa-grey-dark hover:bg-sa-cyan text-sa-blue hover:text-white font-semibold py-4 px-8 rounded-full w-full text-2xl md:w-1/3 sm:mt-0 xs:mt-0 lg:w-1/4 xl:w-1/4">View scores</button>
                </div>
`;
          quizQuestion.innerHTML = quizStr;
          // Make an element with saying quiz complete

          document.getElementById("show").addEventListener("click", function(e) {
            saveScore(score, quizIndex);
            if (organisation.organisation_id) {
              poster(organisation.organisation_id, organisation.organisation_name);
            }

            if (organisation.organisations_name) {
              poster(organisation.organisations_id, organisation.organisations_name);
            }

            document.getElementById('results').classList.remove("hidden");
            let quizStr = `

         <div class="mb-8 p-2 w-full flex flex-wrap">
            <div class="h-auto  w-full lg:w-1/2">
            
            <table class="table-fixed m-auto">
  <thead>
    <tr>
      <th class="w-1/2 px-4 py-2"><h2 class="text-black">Sections</h2></th>
      <th class="w-1/4 px-4 py-2"><h2 class="text-black">Score</h2></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black">${quizzes[0].name}</h4></td>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black">${quizzes[0].score}/5</h4></td>
    </tr>
    <tr>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black">${quizzes[1].name}</h4></td>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black">${quizzes[1].score}/5</h4></td> 
    </tr>
    <tr>
      <td class="border pt-5 pl-3 pr-2"><h4 class="text-black">${quizzes[2].name}</h4></td>
      <td class="border pt-5 pl-3 pr-2"><h4 class="text-black">${quizzes[2].score}/5</h4></td>    
    </tr>
      <tr>
      <td class="border pt-5 pl-3 pr-2"><h4 class="text-black">${quizzes[3].name}</h4></td>
      <td class="border pt-5 pl-3 pr-2"><h4 class="text-black">${quizzes[3].score}/5</h4></td>  
    </tr>
      <tr>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black">${quizzes[4].name}</h4></td>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black">${quizzes[4].score}/5</h4></td>   
    </tr>
     <tr>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black">Total</h4></td>
      <td class="border pt-5 pl-3 pr-3"><h4 class="text-black"><span id="quiz2"></span></h4></td>   
    </tr>
  </tbody>
</table>
            
</div>
            <div class="h-auto w-full lg:w-1/2">
            
            <div class="inline-block align-middle text-center xl:text-left lg:text-left mt-3 xl:mt-32 lg:mt-32 md:mt-3 sm:mt-3 xs:mt-3 md:text-center sm:text-center xs:text-center">
            
            <h4 class="text-black "><span id="complete"></span></h4>

            <h4 class="text-black "><span id="quizText"></span></h4> 
            </div>
</div>
          </div>
                    `;
            quizForm.innerHTML = quizStr;

            endScore();
            const end1Score = quizzes[0].score + quizzes[1].score + quizzes[2].score + quizzes[3].score + quizzes[4].score;
            if (end1Score > 20) {
              endOne();
            } else if (end1Score >= 15 && end1Score <= 20) {
              endTwo();
            } else if (end1Score >= 10 && end1Score <= 14) {
              endThree();
            } else if (end1Score < 10) {
              endFour();
            }

          });
        }
      }
    }, 800);

  }, false);
}

// Build the question

// Add the score to the element
function addScore(score) {
  const quizScore = document.getElementById("quizScore");
  quizScore.innerHTML = 'Score:' + '&nbsp;&nbsp;' + score + '/5';
}

function saveScore(score, quizIndex) {
  quizzes[quizIndex]['score'] = score;
}

function saveOrg() {
  let org1 = document.getElementById('getFname').options[document.getElementById('getFname').selectedIndex].value;
  let org3 = document.getElementById('getFname').options[document.getElementById('getFname').selectedIndex].text;
  let org2 = document.getElementById('organisationName').value;
  let organisationNameLength = document.getElementById("organisationName").value.length;

  if (org1 === 'other' && organisationNameLength > 3) {
    organisation['organisations_id'] = org1;
    organisation['organisations_name'] = org2;
  } else {
    organisation['organisation_id'] = org1;
    organisation['organisation_name'] = org3;
  }
  // console.log(org1);
  // console.log(org2);
  // console.log(organisation);
}

function endScore() {
  const end1Score = quizzes[0].score + quizzes[1].score + quizzes[2].score + quizzes[3].score + quizzes[4].score;
  let quiz1 = document.getElementById("quiz2");
  quiz1.innerHTML = end1Score + '/25';
}

function endOne() {
  let endOneText = 'You are well on the way to being an award winning age friendly customer service officer.';
  let quiz2 = document.getElementById("quizText");
  quiz2.innerHTML = endOneText;
}

function endTwo() {
  let endTwoText = 'You can identify where you need more support, training or coaching to develop your skills.';
  let quiz3 = document.getElementById("quizText");
  quiz3.innerHTML = endTwoText;
}

function endThree() {
  let endThreeText = 'Your age friendliness needs to be reviewed with your peers and senior staff so that you have the support you need to do this.';
  let quiz4 = document.getElementById("quizText");
  quiz4.innerHTML = endThreeText;
}

function endFour() {
  let endFourText = 'You are not getting enough opportunities to improve your age friendly approach to customers and should be addressed promptly with your manager.';
  let quiz5 = document.getElementById("quizText");
  quiz5.innerHTML = endFourText;
}

// Build the answers inside the question
function buildAnswers(answers, question, qI) {
  let answerStr = '';
  // let id = "id" + Math.random().toString(18).slice(2);
  answers.forEach(function(answer, aI) {
    let letter = String.fromCharCode(65 + aI);
    answerStr += `
        
        
<div class=" mr-12 xl:mr-24 lg:mr-24 md:mr-24 sm:mr-24 xs:mr-24 mb-10">

    <label style="order:" class="flex cursor-pointer">  
                 <span class="btnAnswer flex p-2 cursor-pointer bg-sa-grey hover:bg-sa-cyan hover:text-white font-semibold py-4 px-8">
                        <input id="quest" class="hidden" type="radio" name="question-${qI}" data-correct="${question.correct === aI}" class="flex text-center items-center justify-center cursor-pointer">
                        <span class="text-2xl text-center ml-9">${answer}</span>
                </label> 
  </div>
  
         `;
  });
  return answerStr;
}

init('quiz001');
